import React from "react";

interface EmptyStateContactsProps {
  searchedText: string;
}
const EmptyStateResult = ({ searchedText }: EmptyStateContactsProps) => {
  return (
    <div className="rounded p-4 text-center">
      <i className="bx bx-info-circle fs-1 mb-3" />
      <div>Nenhum registro encontrado "{searchedText}".</div>
    </div>
  );
};

export default EmptyStateResult;
